<template>
  <!-- Dynamic component loading with fallback -->
  <component 
    :is="notificationComponent"
    :notification="notification"
    @notification-read="$emit('notificationRead', $event)"
    @popup-state-changed="$emit('popupStateChanged', $event)"
  />
</template>

<script setup>
import { defineProps, defineEmits, computed } from 'vue';
import DefaultNotification from './types/DefaultNotification.vue';
import MeetingNotification from './types/MeetingNotification.vue';
import ConnectionRequestNotification from './types/ConnectionRequestNotification.vue';
import ConnectionAcceptedNotification from './types/ConnectionAcceptedNotification.vue';
import ConnectionDeclinedNotification from './types/ConnectionDeclinedNotification.vue';

// Define props
const props = defineProps({
  notification: {
    type: Object,
    required: true
  }
});

// Define emits - needed for $emit in template
defineEmits(['notificationRead', 'popupStateChanged']);

// Switch-based component resolution
const notificationComponent = computed(() => {
  const notificationType = props.notification?.data?.type || props.notification?.notification_type;
  
  switch (notificationType) {
    case 'meeting':
    case 'meeting_invite':
    case 'meeting_reminder':
    case 'meeting_update':
      return MeetingNotification;

    case 'connection_request':
      return ConnectionRequestNotification;

    case 'connection_accepted':
      return ConnectionAcceptedNotification;

    case 'connection_declined':
      return ConnectionDeclinedNotification;
    
    // Add more custom notification types here as needed
    // case 'custom_type':
    //   return CustomNotification;
    
    default:
      // Fallback to default notification for all other types
      return DefaultNotification;
  }
});
</script>
